import { useState, useEffect, useRef } from 'react';
import styles from "./styles/calculator.module.css";
import Navbar from "../component/navbar/Navbar";
import Banner from '../component/banner/Banner';
import bannerCalc from "../assets/images/priceBanner.png";
import Table from '../component/table/Table';
import lineLP from "../assets/images/lineLP.png";
import lineRP from "../assets/images/lineRP.png";
import Footer from '../component/footer/Footer';
import Adult from "../assets/images/adultRoad.png";
import Child from "../assets/images/childRoad.png";
import Box from '../component/box/Box';

const Calculator = () => {
  const [numChildren, setNumChildren] = useState(0);
  const [numAdults, setNumAdults] = useState(0);
  const [playTime, setPlayTime] = useState(0);
  const [totalCost, setTotalCost] = useState(0);


  const childPlayCost = 2;
  const adultPlayCost = 4.5;
  const minPlayTime = 30;

  function calculateParkCost() {
    const totalPlayTime = Math.ceil(Math.max(minPlayTime, playTime));
    const childCost = numChildren * childPlayCost * totalPlayTime;
    const adultCost = numAdults * adultPlayCost * totalPlayTime;
    const entranceFee = 10 * (numChildren + numAdults);
    const total = entranceFee + childCost + adultCost;
    setTotalCost(total);
  }

  function handleNumChildrenChange(event) {
    const value = parseInt(event.target.value) || 0;
    setNumChildren(value);
  }

  function handleNumAdultsChange(event) {
    const value = parseInt(event.target.value) || 0;
    setNumAdults(value);
  }

  function handlePlayTimeChange(event) {
    const value = parseInt(event.target.value) || 0;
    setPlayTime(value);
  }
  const [scrollPositions, setScrollPositions] = useState([0, 0]);
  const titleRefs = [useRef(null), useRef(null)];

  useEffect(() => {
    const handleScroll = () => {
      const positions = titleRefs.map((ref) => {
        const titleTop = ref.current.offsetTop;
        const titleHeight = ref.current.offsetHeight;
        const scrollTop = window.scrollY;
        const scrollBottom = scrollTop + window.innerHeight;

        // check if the title is in view
        if (scrollTop < titleTop + titleHeight && scrollBottom > titleTop) {
          const progress = (scrollBottom - titleTop) / (titleHeight + window.innerHeight);
          return progress;
        } else {
          return 0;
        }
      });

      setScrollPositions(positions);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const titleStyles = scrollPositions.map((progress, index) => ({
    background: `linear-gradient(to left, #5618C5 ${progress * 180}%, transparent 0)`,
  }));

  return (
    <>
      <div>
        <Navbar />
      </div>
      <div className={styles.content}>
        <Banner bannerImage={bannerCalc} mouseImage={styles.non} />
      </div>
      <div className={styles.tableContainer}>
        <Table />
      </div>
      <div className={styles.paragraphContainer}>
        <p className={styles.paragraph}>
          هزینه ورودی برای هر نفر(کودک، بزرگسال، والدین و ...) 10 هزار تومانه. برای استفاده از بازی ها باید از پذیرش دستبند بگیرید و دستبند رو شارژ کنید.
        </p>
        <p className={styles.paragraph}>
          شارژ دستبند به صورت مفید کم میشه.یعنی وقتی مشغول بازی هستید شارژ دستبند کم میشه و در زمان استراحت می‌تونید دستبند رو غیر فعال کنید.
        </p>
        <p className={styles.paragraph}>
          شارژ باقی مونده دستبند، در مراجعه بعدی قابل استفاده است.ولی امکان پس دادن اون به صورت نقدی وجود نداره.
        </p>
        <p className={styles.paragraph}>
          درصورتی که بیشتر از مبلغ شارژ اولیه از محوطه بازی استفاده کنید،هزینه اضافه وقت خروج از شما گرفته میشه.(هر دقیقه ۳۰۰۰ تومان برای محوطه بازی بزرگسالان و ۱۵۰۰ تومان برای محوطه بازی کودکان)
        </p>

      </div>

      <div className={styles.containerTitle}>
        <img className={styles.lineFront} src={lineRP} alt="lineR" />
        <div className={styles.titleBackground}>
          <h1 ref={titleRefs[0]} style={titleStyles[0]} className={styles.titleText}>
            {" "}
            تعرفه فضای بازی بزرگسال
          </h1>
        </div>
        <img className={styles.lineFront} src={lineLP} alt="lineL" />
      </div>
      <div className={styles.roadwayContainer}>
        <img className={styles.adultImg} src={Adult} alt="adult" />
      </div>

      <div className={styles.containerTitle}>
        <img className={styles.lineFront} src={lineRP} alt="lineR" />
        <div className={styles.titleBackground}>
          <h1 ref={titleRefs[1]} style={titleStyles[1]} className={styles.titleText}>
            {" "}
            تعرفه فضای بازی کودک
          </h1>
        </div>
        <img className={styles.lineFront} src={lineLP} alt="lineL" />
      </div>
      <div className={styles.roadwayContainer}>
        <img className={styles.adultImg} src={Child} alt="adult" />
      </div>

      <div className={styles.calculateContainer}>

        <label className={styles.counter}>
          تعداد کودکان:
          <input className={styles.input} type="number" value={numChildren} onChange={handleNumChildrenChange} />
        </label>
        <br />
        <label className={styles.counter}>
          تعداد بزرگسالان:
          <input className={styles.input} type="number" value={numAdults} onChange={handleNumAdultsChange} />
        </label>
        <br />
        <label className={styles.counter}>
          زمان بازی (دقیقه):
          <input className={styles.input} type="number" value={playTime} onChange={handlePlayTimeChange} />
        </label>
        <br />
        <button className={styles.calcBtn} onClick={calculateParkCost}>محاسبه</button>
        <br />

        <div className={styles.cost} >
          هزینه نهایی: {totalCost.toFixed(3)} تومان
        </div>

        <div>
          <p className={styles.paragraph}>
          زمان بازی در هلیوم پارک به صورت مفید کم میشه. یعنی وقتی مشغول بازی هستید شارژ دستبند کم می‌شه و زمان استراحت می‌تونید دستبند رو غیرفعال کنید.
          </p>
        </div>
      </div>
      <div>
        <Box/>
      </div>
      <div>
        <Footer />
      </div>
    </>
  );
}

export default Calculator;